<template>
	<div class="opts_wrap" v-loading="loading">
		<div class="opts_line">
			<div class="con">
				<el-input v-model="form.logistics_code" clearable>
					<p slot="prefix" class="label_title">快递单号：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line">
			<p class="txt">物流公司：</p>
			<div class="con">
				<el-select class="w100" v-model="info.company_code" placeholder="请选择" @change="companyChange" clearable>
					<el-option v-for="item in companies" :key="item.code" :label="item.name" :value="item.code">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="btn_wrap">
			<p class="btn" @click="saveBtn()">提交</p>
			<p class="btn" @click="cancel()">取消</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	name: "orderDeliver",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		},
		order_id: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			address:'',
			info:'',
			form:{
				logistics_company_id:'',
				logistics_code:''
			},
			companies:[],
			loading: false
		};
	},
	
	created(){
	},
	mounted() {
		
		this.init()
	},
	
	computed:{
		...mapState({
			
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.address = ''
				this.init()
			}
		}
	},
	
	methods: {
		...mapActions({
			getSupplierOrderDeliverInfo:"ucenter/getSupplierOrderDeliverInfo",
			opSupplierOrderDeliver:"ucenter/opSupplierOrderDeliver",
		}),
		init(){
			this.loading = true
			var param = {order_id:this.order_id}
			this.getSupplierOrderDeliverInfo({data:param,success:(res)=>{
				if(res.code===200){
					console.log(res)
					this.info = res.data.info
					this.companies = res.data.companies
					if(this.info.company_code){
						let company = this.companies.find(val => val.code == this.info.company_code)
						this.form = {logistics_company_id:company.id,logistics_code:this.info.logistics_code}
						// console.log(this.form)
					}else{
						this.form = {logistics_company_id:'',logistics_code:''}
					}
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.loading = false
			}})
		},
		companyChange(e){
			let companies = this.companies
			let company = companies.find(val => val.code == e)
			this.form.logistics_company_id = company?company.id:''
		},
		bindCopy(){
			var str = ''
			str += '收件人：'+this.address.name+' '
			str += '手机号：'+this.address.name+' '
			str += '地址：'+this.address.province+this.address.city+this.address.town+this.address.detail
			var input = document.createElement("input"); // 创建input对象
			input.value = str; // 设置复制内容
			document.body.appendChild(input); // 添加临时实例
			input.select(); // 选择实例内容
			document.execCommand("Copy"); // 执行复制
			document.body.removeChild(input); // 删除临时实例
			this.$message({
				message: '复制链接成功',
				type: 'success'
			});
	
		},
		cancel(){
			this.$emit('close', {})
		},
		saveBtn(){
			let that = this
			let param = {order_id:this.order_id}
			param = Object.assign(this.form,param)
			if(!param.logistics_code){
				that.$message({
					type: 'warning',
					message: '请输入快递单号'
				})
				return
			}
			if(!param.logistics_company_id){
				that.$message({
					type: 'warning',
					message: '请选择快递公司'
				})
				return
			}
			that.$confirm('确认发货操作?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.opSupplierOrderDeliver({data:param,success:(res)=>{
					if(res.code == 200){
						that.$message({
							type: 'success',
							message: res.msg
						})
						this.$emit('success')
						this.$emit('close')
					}else{
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}})
			}).catch((res) => {
				console.log(res)
			});
		}
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line{display: flex;align-items: center;position: relative;margin-bottom: 30px;}
	.opts_line .txt{width: 80px;text-align: left;font-size: 14px;position: absolute;left: 14px;z-index: 1;color: #C0C4CC;}
	.opts_line .con{flex: 1;width: 0;margin-left: 0px;display: flex;align-items: center;}
	.opts_line .con .t{font-size: 14px;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}
	.w100{width: 100%;}
	.s_line{padding:0 12px;height: 34px;line-height: 34px;border:1px solid #DCDFE6;border-radius:4px;width: 100%;}
	.s_line .label{color:#C0C4CC;font-size:14px;width: 68px;display:inline-block;}
	.s_line .info{display:inline-block;}
	
	.el-input{height: 34px;line-height: 34px;}
	/deep/.el-input__prefix{height:34px;line-height:34px;margin-left:15px;left: 0 !important;}
	/deep/.el-select .el-input__inner{padding-left:80px;height:34px;line-height:34px;}
	/deep/.el-input--prefix .el-input__inner, .el-cascader .el-input .el-input__inner{padding-left:80px;height: 34px !important;}
</style>
